// Generouted, changes to this file will be overriden
/* eslint-disable */

import { components, hooks, utils } from '@generouted/react-router/client'

export type Path =
  | `/`
  | `/account`
  | `/account/modify`
  | `/auth/find-password`
  | `/auth/login/apple`
  | `/auth/login/google`
  | `/auth/login/kakao`
  | `/auth/login/naver`
  | `/auth/reset-password/:token`
  | `/chat`
  | `/chat/:chatId`
  | `/cloud-chat/:chatId`
  | `/cloud-msg/:fcmId`
  | `/home`
  | `/home/create-meeting`
  | `/home/create-rfi`
  | `/home/search`
  | `/live`
  | `/login`
  | `/oauth-signup`
  | `/policy/privacy`
  | `/policy/terms-of-service`
  | `/projects`
  | `/projects/:projectId`
  | `/projects/:projectId/contractbill/bills`
  | `/projects/:projectId/contractbill/bills/:billId`
  | `/projects/:projectId/contractbill/contracts`
  | `/projects/:projectId/contractbill/contracts/:contractId`
  | `/projects/:projectId/drawing`
  | `/projects/:projectId/meetings`
  | `/projects/:projectId/meetings/:meetingId`
  | `/projects/:projectId/meetings/:meetingId/modify`
  | `/projects/:projectId/meetings/create`
  | `/projects/:projectId/meetings/search`
  | `/projects/:projectId/reports`
  | `/projects/:projectId/reports/:reportId`
  | `/projects/:projectId/resource-input`
  | `/projects/:projectId/rfis`
  | `/projects/:projectId/rfis/:rfiId`
  | `/projects/:projectId/rfis/:rfiId/modify`
  | `/projects/:projectId/rfis/create`
  | `/projects/:projectId/rfis/search`
  | `/projects/:projectId/schedules`
  | `/sign-up`

export type Params = {
  '/auth/reset-password/:token': { token: string }
  '/chat/:chatId': { chatId: string }
  '/cloud-chat/:chatId': { chatId: string }
  '/cloud-msg/:fcmId': { fcmId: string }
  '/projects/:projectId': { projectId: string }
  '/projects/:projectId/contractbill/bills': { projectId: string }
  '/projects/:projectId/contractbill/bills/:billId': { projectId: string; billId: string }
  '/projects/:projectId/contractbill/contracts': { projectId: string }
  '/projects/:projectId/contractbill/contracts/:contractId': { projectId: string; contractId: string }
  '/projects/:projectId/drawing': { projectId: string }
  '/projects/:projectId/meetings': { projectId: string }
  '/projects/:projectId/meetings/:meetingId': { projectId: string; meetingId: string }
  '/projects/:projectId/meetings/:meetingId/modify': { projectId: string; meetingId: string }
  '/projects/:projectId/meetings/create': { projectId: string }
  '/projects/:projectId/meetings/search': { projectId: string }
  '/projects/:projectId/reports': { projectId: string }
  '/projects/:projectId/reports/:reportId': { projectId: string; reportId: string }
  '/projects/:projectId/resource-input': { projectId: string }
  '/projects/:projectId/rfis': { projectId: string }
  '/projects/:projectId/rfis/:rfiId': { projectId: string; rfiId: string }
  '/projects/:projectId/rfis/:rfiId/modify': { projectId: string; rfiId: string }
  '/projects/:projectId/rfis/create': { projectId: string }
  '/projects/:projectId/rfis/search': { projectId: string }
  '/projects/:projectId/schedules': { projectId: string }
}

export type ModalPath = `/chat/create` | `/privacy` | `/terms-of-service` | `/user-profile`

export const { Link, Navigate } = components<Path, Params>()
export const { useModals, useNavigate, useParams } = hooks<Path, Params, ModalPath>()
export const { redirect } = utils<Path, Params>()
